import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import { dehydrateFormData, getClonedMemePostData } from '../../utils/formDataParser';
import useService from '../../../useService';
import { TMemeDehydratedData, TSubmitMemeData } from '../../utils/types';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateMeme } = useService();

	const cloneMeme = (memePostData: TMemeDehydratedData) => {
		setShowLoader(true);
		requestCreateMeme(app.appName, memePostData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while cloning the meme', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Meme created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: TSubmitMemeData) => {
		cloneMeme(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: getClonedMemePostData(_get(location, ['state', 'rowData'], EMPTY_OBJECT)),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
